/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { UploadedFileFromJSON, UploadedFileToJSON } from './UploadedFile';
export function SiteSectionDocumentDocumentFromJSON(json) {
    return SiteSectionDocumentDocumentFromJSONTyped(json, false);
}
export function SiteSectionDocumentDocumentFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        id: !exists(json, 'id') ? undefined : json['id'],
        largeThumbnail: !exists(json, 'large_thumbnail') ? undefined : UploadedFileFromJSON(json['large_thumbnail']),
        title: !exists(json, 'title') ? undefined : json['title']
    };
}
export function SiteSectionDocumentDocumentToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        id: value.id,
        large_thumbnail: UploadedFileToJSON(value.largeThumbnail),
        title: value.title
    };
}
